<template>
  <div class="course-list">

    <!-- 表头 -->
    <div class="course-list-hd">
      <div class="course-list-hd-left">
        <span class="course-list-title">选课列表</span>
        <span v-if="list && list.length" class="course-count">{{ list.length }} 门</span>
      </div>
      <el-button v-if="editable" size="mini" class="btn btn--blue" @click="inputcoursedialog = true"><i class="el-icon-plus" /> 添加选课</el-button>
    </div>

    <!-- 空状态 -->
    <div v-if="!list || !list.length" class="course-empty">
      <i class="el-icon-notebook-2 course-empty-icon" />
      <div class="course-empty-text">暂无选课记录</div>
      <el-button v-if="editable" size="mini" class="btn btn--blue" style="margin-top:10px" @click="inputcoursedialog = true">
        <i class="el-icon-plus" /> 添加第一门课
      </el-button>
    </div>

    <!-- 课程列表：按学年分组 -->
    <div v-else class="course-items">
      <div v-for="group in sortedGroups" :key="group.year">
        <!-- 学年标题 -->
        <div class="year-header">
          <span class="year-label">{{ group.year }} 学年</span>
          <span class="year-count">{{ group.items.length }} 门</span>
        </div>
        <!-- 该学年课程 -->
        <div
          v-for="item in group.items"
          :key="item._index"
          class="course-item"
        >
          <div class="course-item-main">
            <div class="course-item-top">
              <span class="course-code">{{ item.Course ? item.Course.CourseCode : '课程资料缺失' }}</span>
              <span class="course-name">{{ item.Course && item.Course.CourseName }}</span>
              <span v-if="item.Term" class="term-badge" :class="termClass(item.Term)">{{ item.Term }}</span>           
            </div>
          </div>
          <span v-if="editable" class="course-remove" @click="deletecourse(item._index)">
            <i class="el-icon-close" />
          </span>
        </div>
      </div>
    </div>

    <!-- 弹窗 -->
    <el-dialog
      append-to-body
      destroy-on-close
      :visible.sync="inputcoursedialog"
      width="700px"
      title="添加选课"
      @close="inputcoursedialog = false"
    >
      <input-course-form v-if="inputcoursedialog && editable" :SchoolName="SchoolName" @createcourse="newcourse" @cancel="inputcoursedialog = false" />
    </el-dialog>

  </div>
</template>

<script>
import InputCourseForm from './InputCourseForm.vue'

export default {
  name: 'CourseList',
  components: { InputCourseForm },
  props: {
    list:       { type: Array, default: () => [] },
    SchoolName: { type: String, default: '' },
    editable:   { type: Boolean, default: true }
    
  },
  data() {
    return { inputcoursedialog: false }
  },
  computed: {
    // 返回数组而不是对象，Vue 2 v-for 对象有坑
    sortedGroups() {
      const map = {}
      this.list.forEach((item, index) => {
        const year = new Date(item.SchoolYear).getFullYear()
        if (!map[year]) map[year] = []
        map[year].push({ ...item, _index: index })
      })
      return Object.keys(map)
        .sort((a, b) => b - a)
        .map(year => ({ year, items: map[year] }))
    }
  },
  methods: {
    termClass(term) {
      if (term.startsWith('S')) return 'term-s'
      if (term.startsWith('T')) return 'term-t'
      return 'term-default'
    },
    deletecourse(index) {
      if (!this.editable) return
      this.list.splice(index, 1)
    },
    newcourse(course) {
      if (!this.editable) return
      if (!this.list.length) {
        this.list.push(course)
      } else {
        const dup = this.list.some(c =>
          c.Course && c.Course.CourseCode === course.Course.CourseCode &&
          new Date(c.SchoolYear).getFullYear() === new Date(course.SchoolYear).getFullYear()
        )
        if (dup) { this.$message.error('已添加相同课程'); return }
        this.list.push(course)
      }
      this.inputcoursedialog = false
    }
  }
}
</script>

<style scoped>
.course-list {
  border: 0.5px solid rgba(0,0,0,0.08);
  border-radius: 10px;
  overflow: hidden;
  background: #fff;
}

/* 表头 */
.course-list-hd {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 11px 14px;
  border-bottom: 0.5px solid rgba(0,0,0,0.06);
  background: #fafafa;
}
.course-list-hd-left { display: flex; align-items: center; gap: 8px; }
.course-list-title   { font-size: 13px; font-weight: 500; color: #1a1a1a; }
.course-count {
  font-size: 11px; font-weight: 500;
  color: #0C447C; background: #E6F1FB;
  padding: 1px 7px; border-radius: 10px;
}

/* 空状态 */
.course-empty {
  display: flex; flex-direction: column;
  align-items: center; padding: 32px 20px;
}
.course-empty-icon { font-size: 28px; color: #ddd; margin-bottom: 8px; }
.course-empty-text { font-size: 13px; color: #bbb; }

/* 学年标题 */
.year-header {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 6px 14px;
  background: #f7f8fa;
  border-top: 0.5px solid rgba(0,0,0,0.05);
  border-bottom: 0.5px solid rgba(0,0,0,0.05);
}
.year-label { font-size: 11px; font-weight: 500; color: #aaa; letter-spacing: 0.04em; }
.year-count { font-size: 11px; color: #ccc; }

/* 课程行 */
.course-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 14px;
  gap: 10px;
  border-bottom: 0.5px solid rgba(0,0,0,0.04);
  transition: background 0.12s;
}
.course-item:last-child { border-bottom: none; }
.course-item:hover      { background: #f9fbff; }

.course-item-main {
  display: flex;
  align-items: center;
  gap: 8px;
  flex: 1;
  min-width: 0;
}

.course-item-top {
  display: flex;
  align-items: center;
  gap: 6px;
  flex: 1;
  min-width: 0;
}
.course-code {
  font-size: 12px; font-weight: 500;
  color: #0C447C; background: #E6F1FB;
  padding: 2px 7px; border-radius: 4px;
  white-space: nowrap; flex-shrink: 0;
}
.course-name {
  font-size: 13px;
  color: #333;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 1.4;
  flex: 1;
  min-width: 0;
}

/* 学期徽标 */
.term-badge {
  display: inline-flex; align-items: center; justify-content: center;
  height: 18px; padding: 0 6px;
  border-radius: 4px; font-size: 11px; font-weight: 500; flex-shrink: 0;
}
.term-s       { background: #EAF3DE; color: #27500A; }
.term-t       { background: #EEEDFE; color: #3C3489; }
.term-default { background: #f0f0f0; color: #888; }

/* 移除按钮 */
.course-remove {
  display: inline-flex; align-items: center; justify-content: center;
  width: 24px; height: 24px;
  border-radius: 6px; cursor: pointer; color: #ccc; flex-shrink: 0;
  transition: color 0.12s, background 0.12s;
}
.course-remove:hover { color: #E24B4A; background: #FCEBEB; }
.course-remove i     { font-size: 12px; }

/* 通用按钮 */
.btn {
  height: 26px !important; padding: 0 9px !important;
  border-radius: 6px !important; font-size: 12px !important;
  border: 0.5px solid rgba(0,0,0,0.1) !important;
  background: #fff !important; color: #555 !important;
  display: inline-flex !important; align-items: center !important; gap: 3px !important;
}
.btn:hover       { background: #f5f5f5 !important; }
.btn--blue       { background: #E6F1FB !important; border-color: #B5D4F4 !important; color: #0C447C !important; }
.btn--blue:hover { background: #cde4f7 !important; }
</style>
